import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { HomepageComponent } from './homepage.component';
import { NoutatiComponent } from './noutati/noutati.component';
import { FaqComponent } from './faq/faq.component';
import { UtileComponent } from './utile/utile.component';
import { ContactComponent } from './contact/contact.component';
import { AcasaComponent } from './acasa/acasa.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ArticolComponent } from './articol/articol.component';
import { DialogComponent } from './dialog/dialog.component';
import { RegistreComponent } from './registre/registre.component';
import { AccessibilityToolbarModule } from '../components/accessibility-toolbar/accessibility-toolbar.module';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { TaxaDezvoltareUrbanaComponent } from './taxa-dezvoltare-urbana/taxa-dezvoltare-urbana.component';
import { BulevartComponent } from './bulevart/bulevart.component';
import { DeclaratiiModule } from './declaratii/declaratii.module';
import { CarieraModule } from './cariera/cariera.module';
import { AchizitiiModule } from './achizitii/achizitii.module';
import { SharedFooterModule } from './shared-footer/shared-footer.module';
import { RegistreUrbanismComponent } from './registre/registre-urbanism/registre-urbanism.component';
import { RegistreAutorizariComercialeComponent } from './registre/registre-autorizari-comerciale/registre-autorizari-comerciale.component';

@NgModule({
    declarations: [HomepageComponent, AcasaComponent, NoutatiComponent, FaqComponent, UtileComponent, ContactComponent, ArticolComponent, DialogComponent, RegistreComponent, AccessibilityComponent, TaxaDezvoltareUrbanaComponent, BulevartComponent, RegistreUrbanismComponent, RegistreAutorizariComercialeComponent],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        AccessibilityToolbarModule,
        DeclaratiiModule,
        CarieraModule,
        AchizitiiModule,
        SharedFooterModule
    ],
})
export class HomepageModule { }
